import * as Joi from 'joi';

const applicationStatusSchema = Joi.object({
  applicationStatus: Joi.object().required().messages({
    'any.required': `Please select a Application Status`,
    'object.base': `Please select a Application Status`,
  }),
  internalRemarks: Joi.string().allow('').max(1000).messages({
    'string.max': 'Internal Remarks is too long',
  }),
  candidateRemarks: Joi.string().allow('').max(1000).messages({
    'string.max': 'Candidate Remarks is too long',
  }),
});

export default applicationStatusSchema;
